export const OPEN_PAYMENTS_TAG_TYPE = 'OpenPayments' as const;
